<script setup>
const props = defineProps(["class"]);
</script>

<template>
	<svg
		:class="class"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M19 5.29238L5 19M19 18.7076L5 5"
			stroke="currentColor"
			stroke-width="2"
			stroke-linecap="square"
		/>
	</svg>
</template>
